import { render, staticRenderFns } from "./DetailItem.vue?vue&type=template&id=760762ce&scoped=true"
import script from "./DetailItem.vue?vue&type=script&lang=js"
export * from "./DetailItem.vue?vue&type=script&lang=js"
import style0 from "./DetailItem.vue?vue&type=style&index=0&id=760762ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760762ce",
  null
  
)

export default component.exports